"use client";

import { useEffect } from "react";
import { HeroSection2 } from "@/components/public/HeroSection2";
import { TrustIndicatorsGallery } from "@/components/public/TrustIndicatorsGallery";
import { ClippingPathDivider } from "@/components/public/ClippingPathDivider";
import { AppleCardsSection } from "@/components/public/AppleCardsSection";
import { Section } from "@/components/public/Section";
import { ServicesGrid } from "@/components/public/ServicesGrid";
import FeatureGrid, { sampleFeatures } from "@/components/public/FeatureGrid";
import { OperationsLifecycle } from "@/components/public/OperationsLifecycle";
import { QualityShowcase } from "@/components/public/QualityShowcase";
import { PlatformShowcase } from "@/components/public/PlatformShowcase";
import { QuoteBlock } from "@/components/public/QuoteBlock";

export function LandingPageClient() {

  useEffect(() => {
    console.log('[LandingPageClient] useEffect - component mounted');
    // Add keyframes for the fade-in animation
    const style = document.createElement('style');
    style.textContent = `
      @keyframes fadeInUp {
        from {
          opacity: 0;
          transform: translateY(20px);
        }
        to {
          opacity: 1;
          transform: translateY(0);
        }
      }
    `;
    document.head.appendChild(style);

    // Cleanup function to remove the style when component unmounts
    return () => {
      document.head.removeChild(style);
    };
  }, []);

  return (
    <>
      {/* Hero Section - Full width, no grid margins */}
      <div id="hero">
        <HeroSection2 />
      </div>

      {/* Feature Grid - Right after hero */}
      <Section spacing="relaxed" background="transparent">
        <FeatureGrid 
          features={sampleFeatures}
          cols={4}
          showAccent={true}
        />
      </Section>

      {/* Quote Block - Professional quote with dark theme */}
      <Section spacing="none" background="transparent">
        <QuoteBlock
          quote="Replenico has transformed how we manage property turnovers. The platform gives us complete visibility across our portfolio, and the quality of service is consistently excellent."
          author="Property Manager"
          authorTitle="UK Portfolio Operator"
          image="/assets/REPLENICO/host-images/happy-host.JPG"
          imageAlt="Happy property host using Replenico"
        />
      </Section>

      {/* Services Gallery - Modern card slider */}
      <div className="w-full border-t border-gray-200" />
      <Section spacing="relaxed" background="white">
        <ServicesGrid />
      </Section>
      <div className="w-full border-b border-gray-200" />

      {/* Operations Lifecycle - How we operate */}
      <div className="w-full border-t border-gray-200" />
      <Section spacing="relaxed" bgColor="#f8fafc">
        <OperationsLifecycle />
      </Section>

      {/* Quality Showcase - Our linens and towels */}
      <Section spacing="none" background="transparent" extendRight>
        <QualityShowcase />
      </Section>

      {/* Platform Showcase - Full width cards */}
      <div className="w-full border-t border-gray-200" />
      <Section spacing="relaxed" bgColor="#f8fafc" extendRight>
        <PlatformShowcase />
      </Section>

      
      {/* Trust Indicators Gallery - Compact horizontal cards */}
      <div className="w-full border-t border-gray-200" />
      <Section spacing="relaxed" background="transparent">
        <TrustIndicatorsGallery />
      </Section>

      {/* Clipping Path Divider */}
      <ClippingPathDivider />

      {/* Apple Cards Section - Full width with themed background */}
      <AppleCardsSection />

    </>
  );
} 